'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFilm = function TiFilm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 13.3v11.7h13.4v-11.7h-13.4z m11.7 10h-10v-8.3h10v8.3z m3.3-20h-5v3.4h-6.6v-3.4h-5c-2.8 0-5 2.3-5 5v21.7c0 2.8 2.2 5 5 5h5v-3.3h6.6v3.3h5c2.8 0 5-2.2 5-5v-21.7c0-2.7-2.2-5-5-5z m1.7 6.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6v1.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6v1.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6v1.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6v1.7c0 0.9-0.7 1.7-1.7 1.7h-1.6v-3.4h-13.4v3.4h-1.6c-1 0-1.7-0.8-1.7-1.7v-1.7c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7v-1.7c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7v-1.7c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7v-1.7c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7v-1.7c0-0.9 0.7-1.6 1.7-1.6h1.6v3.3h13.4v-3.3h1.6c1 0 1.7 0.7 1.7 1.6v1.7z' })
        )
    );
};

exports.default = TiFilm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/film.js
// module id = 3596
// module chunks = 0